import { Task } from "@/types/v2";
import { IndexDBService } from "../index_db";

export const TasksStorageService = {
  storeTasks: async (tasks: Task[]): Promise<void> => {
    await IndexDBService.set("tasks", tasks);
  },

  storeActiveTask: async (task: Task): Promise<void> => {
    await IndexDBService.set("activeTask", task);
  },

  getTasks: async (): Promise<Task[] | []> => {
    const tasks = await IndexDBService.get<Task[]>("activeTask");
    return tasks ?? [];
  },

  getActiveTask: async (): Promise<Task | null> => {
    const task = await IndexDBService.get<Task>("activeTask");
    return task ?? null;
  },
};
